import React, { Fragment } from 'react';
import Centering from '~/common/components/Centering';
import PropTypes from 'prop-types';

// Import images
import logo from '~/common/images/gh-logo.png';
import {
    MARKETING_SITE_BASE_URL,
    SALES_PHONE_NUMBER_FORMATTED,
    SALES_PHONE_NUMBER_UNFORMATTED
} from '~/common/utils/consts';

// Import Local Styles
import styles from './header.css';

const RenderContactNumber = (headerType) => {
    switch (headerType) {
        case '/ruby':
            return (
                <span className={styles.ruby} >
                    <span className={styles['ruby-copy']}>Talk to the Ruby team: </span><a className={styles['ruby-number']} href="tel:8666117829">866-611-7829</a>
                </span>
            );
        case '/annual-upgrade':
            return (
                <span className={styles.ruby} >
                    <span className={styles['ruby-copy']}>Questions? </span><a className={styles['ruby-number']} href={`tel:${SALES_PHONE_NUMBER_UNFORMATTED}`}>{SALES_PHONE_NUMBER_FORMATTED}</a>
                </span>
            );
        default:
            return (
                <Fragment>
                    {/* eslint-disable */}
                    <span className={styles.support} x-ms-format-detection="none" >
                        Sales: {SALES_PHONE_NUMBER_FORMATTED}
                    </span>
                    <a className={styles.tel} href={`tel:${SALES_PHONE_NUMBER_UNFORMATTED}`}>
                        {SALES_PHONE_NUMBER_FORMATTED}
                    </a>
                </Fragment>
            );
    }
};

const Header = (props) => {
    const { headerType } = props;
    return (
        <header className={styles.header}>
            <Centering modifier={styles.wrapper}>
                <a className={styles.logo} href={MARKETING_SITE_BASE_URL()}>
                    <img
                        alt="Grasshopper"
                        className={styles.logo}
                        src={logo}
                        title="Grasshopper"
                    />
                </a>
                <aside className={styles.numbers}>
                    {RenderContactNumber(headerType)}
                </aside>
            </Centering>
        </header>
    );
};

Header.propTypes = {
    headerType: PropTypes.string
};

export default Header;
